import React, { useRef, Component, useState } from 'react';
import './Web.scss';
import 'font-awesome/css/font-awesome.min.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import InputMask from 'react-input-mask';
import config from  './config/config.json';
import { getPrimaryProducts, getSecondaryProducts, postChat } from "./helpers/postChat.js";
import { sendEmail } from "./helpers/sendEmail.js";
import { getClient, usageLimit, getClientProducts } from "./helpers/getClient.js";
import { createCart, addProductToCart, removeProductFromCart, bulkAddProductToCart, bulkRemoveProductFromCart, addCampaign } from "./helpers/manageCart.js";
import comboImage from './combo-image.png';
import PagueMenosImg from './Pague_menos_1.png';
import IconEnviarImg from './Icon-Enviar.png';
import LOGO_CLINIC_FARMA_2022_2023Img from './LOGO_CLINIC_FARMA_2022_2023.png';
import LOGO_PAGUE_MENOSImg from './LOGO_PAGUE_MENOS.png';
import dipirona1Img from './dipirona1.png';
import dipirona2Img from './dipirona2.webp';
import dipirona3Img from './dipirona3.webp';
import dipirona4Img from './dipirona4.webp';
import tosse1Img from './tosse1.webp';
import tosse2Img from './tosse2.png';
import tosse3Img from './tosse3.png';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import Keyboard from "react-simple-keyboard";
import 'react-simple-keyboard/build/css/index.css';
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import { TypeAnimation } from 'react-type-animation';
import moment from 'moment'
import 'moment/min/locales';
moment.locale('pt-BR');

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a href="" ref={ref} onClick={(e) => {
        e.preventDefault();
        onClick(e);
    }}>
    {children}
    </a>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    className = className + " my-custom-dropdown";

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <Form.Control
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Digite para buscar"
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value.toLowerCase()),
          )}
        </ul>
      </div>
    );
  },
);

const mockedProducts = require('./helpers/mockedProducts.json');

class Web extends Component {
    constructor(props) {
        super(props);
        this.textLog = React.createRef();
        this.textLog1 = React.createRef();
        let systemContent = 'Finja ser um médico';
        this.myRef = React.createRef()
        this.myRefMobile = React.createRef()
        this.state = {
            hasSelectedSymptom: false,
            firstSymptom: '',
            messages: [
                {"role": "system", "content": systemContent},
                {"role": "assistant", "content": "Olá, sou o Assistente de Saúde e irei te ajudar. Qual o sintoma que mais te incomoda?"}
            ],
            chatStatus: true,
            messageSent: '',
            hasSentIdentifier: true,
            identifier: '',
            hasAddedChat: false,
            hasConsent: false,
            chatId: null,
            showIdentifier: !window.location.search.includes('source=webflow_infomativo'),
            isTyping: false,
            hasSentMessage: false,
            isPlatformWeb: true,
            isRecommendingDoctor: false,
            isRenanTest: false,
            hasRenanSentPrompt: false,
            clientToken: '',
            clientId: 0,
            clientLogoOne: '',
            clientLogoTwo: '',
            isClientInvalid: false,
            isClientDigital: true,
            isClientCustomerFacing: false,
            clientModule: '',
            hasEndedChat: false,
            productsList: [],
            cartList: {},
            cartId: '',
            checkedPrivacy: false,
            needDoctorSymptoms: [],
            finalMessages: [],
            finalMessageIndex: 0,
            startFinalMessage: false,
            secondaryProductsList: [],
            cartTicket: 0,
            combo: {},
            comboInCart: 0,
            isLoadingProductsList: false,
            diagnosis: ''
        };
        this.postChat = this.postChat.bind(this);
        this.removeMessageDelay = this.removeMessageDelay.bind(this);
        // this.selectedSymptom = this.selectedSymptom.bind(this);
        this.inputChatChange = this.inputChatChange.bind(this);
        this.setIdentifier = this.setIdentifier.bind(this);
        this.newChat = this.newChat.bind(this);
        this.sliceMessage = this.sliceMessage.bind(this);
        this.shutDownChat = this.shutDownChat.bind(this);
        this.isRecommendingDoctor = this.isRecommendingDoctor.bind(this);
        this.testeRenan = this.testeRenan.bind(this);
        this.checkClientToken = this.checkClientToken.bind(this);
        this.onEnterPress = this.onEnterPress.bind(this);
        this.handleCart = this.handleCart.bind(this);
        this.onKeyPressKeyboard = this.onKeyPressKeyboard.bind(this);
        this.urlIdentifier = this.urlIdentifier.bind(this);
        this.urlCart = this.urlCart.bind(this);
        this.validateConsent = this.validateConsent.bind(this);
        this.manageCartTicket = this.manageCartTicket.bind(this);
        this.handleComboCart = this.handleComboCart.bind(this);
        this.swipeProduct = this.swipeProduct.bind(this);
        
        if (window.location.search.includes('source=teste-renan')) {
            setTimeout(function() {
                this.testeRenan();
            }.bind(this), 300)
        }
    }

    onKeyPressKeyboard(button, isCPF) {
        if (isCPF) {
            if (button == '{bksp}')
                this.setState({ identifier: this.state.identifier.slice(0, -1) });
            else if (button == '{space}')
                this.setState({ identifier: this.state.identifier.concat(' ') });
            else if (button == '{enter}') {
                if (!this.state.checkedPrivacy)
                    alert("Para prosseguir é necessário o aceite da política de privacidade");
                else if (this.state.identifier.length != 11)
                    alert("Preencha corretamente o campo do CPF");
                else
                    this.setIdentifier(false);
            }
            else if (/^\d+$/.test(button) && this.state.identifier.length != 11)
                this.setState({ identifier: this.state.identifier.concat(button) });
        }
        else {
            if (this.state.messageSent == '') {
                this.setState({ messageSent: button });
            }
            else {
                if (button == '{bksp}')
                    this.setState({ messageSent: this.state.messageSent.slice(0, -1) });
                else if (button == '{space}')
                    this.setState({ messageSent: this.state.messageSent.concat(' ') });
                else if (button == '{enter}') {
                    this.postChat();
                    this.setState({ messageSent: '' });
                }
                else
                    this.setState({ messageSent: this.state.messageSent.concat(button) });
            }
        }
    }

    componentDidUpdate() {
        if (this.textLog.current != null)
            this.textLog.current.scrollTop = this.textLog.current.scrollHeight;
    }

    componentDidMount() {
        if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1) {
            this.myRefMobile.current.scrollIntoView()
            this.setState({ isPlatformWeb: false })
        }
        this.checkClientToken();
     }

     urlIdentifier() {
        if (window.location.search.includes('identifier=')) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const identifier = urlParams.get('identifier');
            this.setState({
                identifier: identifier,
                hasSentIdentifier: true
            });
        }
     }

     urlCart() {
        if (window.location.search.includes('cartId=')) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const cartId = urlParams.get('cartId');
            this.setState({
                cartId: cartId
            }, () => {
                addCampaign(cartId, this.state.clientToken, this.state.clientModule);
            });
        }
     }

     checkClientToken() {
        const clientToken = window.location.pathname.substring(9);

        getClient(clientToken)
            .then(res => {
                let _messages = [
                    {"role": "system", "content": "Finja ser um médico"},
                    {"role": "assistant", "content": "Olá, sou o Assistente de Saúde e irei te ajudar."},
                    {"role": "assistant", "content": "Quais os sintomas que mais te incomodam e há quanto tempo eles começaram?"}
                ];

                if (res.data[0].initialMessage && res.data[0].initialMessage !== '') {
                    _messages = [
                        {"role": "system", "content": "Finja ser um médico"},
                        {"role": "assistant", "content": res.data[0].initialMessage}
                    ];
                }

                let _finalMessage = (res.data[0].finalMessage)? res.data[0].finalMessage.split('","') : [];

                ReactGA.event({
                    category: "IA conversacional",
                    action: "IA - token cliente validado",
                    label: `IA - token cliente validado ${res.data[0].id}`
                });

                this.setState({
                    clientToken: clientToken,
                    clientId: res.data[0].id,
                    clientLogoOne: (res.data[0].logoOne)? require(`./${res.data[0].logoOne}`) : '',
                    clientLogoTwo: (res.data[0].logoTwo)? require(`./${res.data[0].logoTwo}`) : '',
                    clientModule: res.data[0].searchProductsModule,
                    isClientDigital: res.data[0].isClientDigital,
                    hasConsent: false,
                    hasSentIdentifier: false,
                    messages: _messages,
                    finalMessages: _finalMessage,
                    isClientCustomerFacing: res.data[0].isCustomerFacing
                }, () => {
                    if (!res.data[0].showIdentifier) {
                        this.setState({
                            identifier: 'x',
                            hasSentIdentifier: true
                        });
                    }
                    this.urlIdentifier();
                    this.urlCart();

                    usageLimit(this.state.clientId, this.state.clientToken)
                        .then(res => {
                            if (res.data.hasReachedLimit)
                                this.setState({ isClientInvalid: true });
                        });
                });
            })
            .catch(err => {
                this.setState({ isClientInvalid: true });
            });
     }

     testeRenan() {
        this.setState({
            hasSentIdentifier: true,
            hasConsent: true,
            isRenanTest: true,
            hasRenanSentPrompt: true
        })
     }

    postChat(event) {
        if (event)
            event.preventDefault();
        let newMessages = this.state.messages;
        newMessages.push({"role": "user", "content": this.state.messageSent});

        if (this.state.isRenanTest) {
            newMessages = [
                {"role": "system", "content": this.state.messageSent}
            ];
            this.setState({
                isRenanTest: false,
                messages: newMessages
            }, () => {
                this.myRef.current.scrollIntoView()
                this.setState({
                    messageSent: '',
                    isTyping: true
                })
            });

            let obj = {
                client: this.state.clientId,
                identifier: this.state.identifier,
                messages: newMessages,
                chatId: this.state.chatId
            };

            postChat(obj, this.state.clientToken, this.state.clientModule)
                .then(res => {

                    ReactGA.event({
                        category: "IA conversacional",
                        action: "IA - mensagem enviada",
                        label: `IA - conversa com id ${this.state.chatId} - mensagem número ${this.state.messages.length}`
                    });

                    let messages = this.state.messages;
                    let pushObj = {
                        role: res.data.role,
                        content: this.sliceMessage(res.data.content)
                    }
                    let chatId = (this.state.chatId === null)? res.data.chatId : this.state.chatId;
                    
                    if (this.isRecommendingDoctor(res.data.content)) {
                        this.shutDownChat(true, false);
                    }
                    else {
                        messages.push(pushObj);
                        this.setState({
                            messages: messages,
                            chatStatus: true,
                            chatId: chatId,
                            isTyping: false,
                            hasSentMessage: false
                        }, () => {
                            if (res.data.content.includes('xyz')) {
                                this.shutDownChat(false, true);
                            }
                            setTimeout(function() {
                                this.myRef.current.scrollIntoView();
                                this.textLog1.current.focus();
                            }.bind(this), 300)
                        })
                    }
                });
        }
        else {
            this.setState({
                chatStatus: false,
                messages: newMessages,
                hasSentMessage: true,
                messageSent: '',
                isTyping: true
            }, () => {
                    this.myRef.current.scrollIntoView();

                    let obj = {
                        client: this.state.clientId,
                        identifier: this.state.identifier,
                        messages: newMessages,
                        chatId: this.state.chatId,
                        hasChatEnded: false,
                        hasFinalMessages: false
                    };

                    if (this.state.startFinalMessage) {
                        let pushObj = {
                            role: 'assistant',
                            content: this.state.finalMessages[this.state.finalMessageIndex]
                        }
                        let _messages = newMessages
                        _messages.push(pushObj);
                        obj.hasChatEnded = true;
                        obj.hasFinalMessages = true;

                        if (this.state.finalMessageIndex + 1 == this.state.finalMessages.length) {
                            postChat(obj, this.state.clientToken, this.state.clientModule);
                            this.shutDownChat(false, true);
                        }

                        this.setState({
                            messages: _messages,
                            chatStatus: true,
                            isTyping: false,
                            hasSentMessage: false,
                            finalMessageIndex: this.state.finalMessageIndex + 1
                        });
                    }
                    else {
                        postChat(obj, this.state.clientToken, this.state.clientModule)
                            .then(res => {

                                ReactGA.event({
                                    category: "IA conversacional",
                                    action: "IA - mensagem enviada",
                                    label: `IA - conversa com id ${this.state.chatId} - mensagem número ${this.state.messages.length}`
                                });

                                if (res.data.content != null) {

                                    let messages = this.state.messages;
                                    let pushObj = {
                                        role: res.data.role,
                                        content: this.sliceMessage(res.data.content)
                                    }
                                    let chatId = (this.state.chatId === null)? res.data.chatId : this.state.chatId;

                                    if (res.data.content.includes('xyz') && this.state.finalMessages.length > 0) {
                                        pushObj = {
                                            role: 'assistant',
                                            content: this.state.finalMessages[0]
                                        }
                                        messages.push(pushObj);
                                        this.setState({
                                            messages: messages,
                                            chatStatus: true,
                                            chatId: chatId,
                                            isTyping: false,
                                            hasSentMessage: false,
                                            startFinalMessage: true,
                                            finalMessageIndex: 1
                                        });
                                    }
                                    else {
                                        messages.push(pushObj);
                                        this.setState({
                                            messages: messages,
                                            chatStatus: true,
                                            chatId: chatId,
                                            isTyping: false,
                                            hasSentMessage: false
                                        }, () => {
                                            if (res.data.diagnosis){
                                                ReactGA.event({
                                                    category: "IA conversacional",
                                                    action: "IA - finalizou a conversa",
                                                    label: `IA - conversa com id ${this.state.chatId}`
                                                });

                                                if (this.state.finalMessages.length > 0) {
                                                    let _messages = this.state.messages;
                                                    messages.push({"role": "system", "content": this.state.finalMessages[0]})
                                                    this.setState({
                                                        messages: _messages,
                                                        finalMessageIndex: 1
                                                    });
                                                }
                                                else {
                                                    this.setState({ isLoadingProductsList: true },
                                                        () => {
                                                            this.shutDownChat(false, true);
                                                            getPrimaryProducts(this.state.clientId, this.state.clientModule, res.data.chatId)
                                                                .then(_res => {
                                                                    if (_res.data.length == 0 && !_res.data.price) {
                                                                        let lastMessages = this.state.messages;
                                                                        lastMessages.pop();
                                                                        lastMessages.push({
                                                                            role: 'assistant',
                                                                            content: '<a href='
                                                                        })

                                                                        this.setState({
                                                                            isRecommendingDoctor: true
                                                                        });
                                                                    }
                                                                    else {
                                                                        if (_res.data.price) {
                                                                            messages.pop();
                                                                            messages.push({
                                                                                role: 'assistant',
                                                                                content: 'Certo, estamos finalizando o chat.'
                                                                            },{
                                                                                role: 'assistant',
                                                                                content: 'Aqui estão os produtos ideiais com os melhores preços.'
                                                                            });

                                                                            this.setState({
                                                                                combo: _res.data,
                                                                                messages: messages,
                                                                                isLoadingProductsList: false
                                                                            })
                                                                        }
                                                                        else {
                                                                            let needDoctorSymptoms = [];
                                                                            for (let i = 0; i < _res.data.length; i++) {
                                                                                if (_res.data[i].products[0] == 'Procurar médico') {
                                                                                    needDoctorSymptoms.push(_res.data[i].symptom)
                                                                                }
                                                                            }

                                                                            if (needDoctorSymptoms.length == _res.data.length && _res.data.length != 0) {
                                                                                let lastMessages = this.state.messages;
                                                                                lastMessages.pop();
                                                                                lastMessages.push({
                                                                                    role: 'assistant',
                                                                                    content: '<a href='
                                                                                })

                                                                                this.setState({
                                                                                    isRecommendingDoctor: true
                                                                                });
                                                                            }

                                                                            else {
                                                                                messages.pop();
                                                                                
                                                                                
                                                                                if(this.state.clientId == 11) {
                                                                                    messages.push({
                                                                                        role: 'appointmentpoc',
                                                                                        content: ''
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'Certo, estamos finalizando o chat.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                    });
                                                                                }
                                                                                else {
                                                                                    messages.push({
                                                                                        role: 'assistant',
                                                                                        content: 'Certo, estamos finalizando o chat.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                    });
                                                                                }

                                                                                this.setState({
                                                                                    productsList: _res.data,
                                                                                    needDoctorSymptoms: needDoctorSymptoms,
                                                                                    messages: messages,
                                                                                    isLoadingProductsList: false
                                                                                });

                                                                                // getSecondaryProducts(this.state.chatId, this.state.clientModule)
                                                                                //     .then(res => {
                                                                                //         this.setState({
                                                                                //             secondaryProductsList: res.data
                                                                                //         });
                                                                                //     });
                                                                            }
                                                                        }
                                                                    }
                                                                })
                                                                .catch(err => {
                                                                    let lastMessages = this.state.messages;
                                                                    lastMessages.push({
                                                                        role: 'assistant',
                                                                        content: '<a href='
                                                                    })

                                                                    this.setState({
                                                                        isRecommendingDoctor: true
                                                                    });
                                                                });
                                                            if (this.state.cartId == '') {
                                                                createCart(this.state.clientToken, this.state.clientModule)
                                                                    .then(_res => {
                                                                        this.setState({ cartId: _res.data.orderFormId })
                                                                    })
                                                            }
                                                        });
                                                }
                                            }

                                            else if (res.data.content.includes('xyz')) {

                                                ReactGA.event({
                                                    category: "IA conversacional",
                                                    action: "IA - chegou mensagem final",
                                                    label: `IA - conversa com id ${this.state.chatId}`
                                                });

                                                if (this.state.finalMessages.length > 0) {
                                                    let _messages = this.state.messages;
                                                    messages.push({"role": "system", "content": this.state.finalMessages[0]})
                                                    this.setState({
                                                        messages: _messages,
                                                        finalMessageIndex: 1
                                                    });
                                                }
                                                else {
                                                    this.shutDownChat(false, true);
                                                    obj.hasChatEnded = true;

                                                    this.setState({ isLoadingProductsList: true }, 
                                                        () => {
                                                            postChat(obj, this.state.clientToken, this.state.clientModule)
                                                                .then(_res => {
                                                                    if (this.state.isClientDigital) {
                                                                        if (_res.data.length == 0 && !_res.data.price) {
                                                                            let lastMessages = this.state.messages;
                                                                            lastMessages.push({
                                                                                role: 'assistant',
                                                                                content: '<a href='
                                                                            })

                                                                            this.setState({
                                                                                isRecommendingDoctor: true,
                                                                                isLoadingProductsList: false
                                                                            });
                                                                        }
                                                                        else {
                                                                            if (_res.data.price) {
                                                                                messages.pop();
                                                                                messages.push({
                                                                                    role: 'assistant',
                                                                                    content: 'Certo, estamos finalizando o chat.'
                                                                                },{
                                                                                    role: 'assistant',
                                                                                    content: 'Aqui estão os produtos ideiais com os melhores preços.'
                                                                                });

                                                                                this.setState({
                                                                                    combo: _res.data,
                                                                                    messages: messages,
                                                                                    isLoadingProductsList: false
                                                                                })
                                                                            }
                                                                            else {
                                                                                let needDoctorSymptoms = [];
                                                                                for (let i = 0; i < _res.data.length; i++) {
                                                                                    if (_res.data[i].products[0] == 'Procurar médico') {
                                                                                        needDoctorSymptoms.push(_res.data[i].symptom)
                                                                                    }
                                                                                }

                                                                                if (needDoctorSymptoms.length == _res.data.length && _res.data.length != 0) {
                                                                                    let lastMessages = this.state.messages;
                                                                                    lastMessages.push({
                                                                                        role: 'assistant',
                                                                                        content: '<a href='
                                                                                    })

                                                                                    this.setState({
                                                                                        isRecommendingDoctor: true,
                                                                                        isLoadingProductsList: false
                                                                                    });
                                                                                }

                                                                                else {
                                                                                    if(this.state.clientId == 11) {
                                                                                        messages.push({
                                                                                        role: 'appointmentpoc',
                                                                                        content: ''
                                                                                        },{
                                                                                            role: 'assistant',
                                                                                            content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                        },{
                                                                                            role: 'assistant',
                                                                                            content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                        });
                                                                                    }
                                                                                    else {
                                                                                        messages.push({
                                                                                            role: 'assistant',
                                                                                            content: 'Certo, estamos finalizando o chat.'
                                                                                        },{
                                                                                            role: 'assistant',
                                                                                            content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                        },{
                                                                                            role: 'assistant',
                                                                                            content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                        });
                                                                                    }

                                                                                    this.setState({
                                                                                        productsList: _res.data,
                                                                                        needDoctorSymptoms: needDoctorSymptoms,
                                                                                        messages: messages,
                                                                                        isLoadingProductsList: false
                                                                                    });

                                                                                    // getSecondaryProducts(this.state.chatId, this.state.clientModule)
                                                                                    //     .then(res => {
                                                                                    //         this.setState({
                                                                                    //             secondaryProductsList: res.data,
                                                                                    //             isLoadingProductsList: false
                                                                                    //         });
                                                                                    //     });
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        getClientProducts(this.state.clientId, _res.data.diagnosis)
                                                                            .then(res1 => {
                                                                                
                                                                                if(this.state.clientId == 11) {
                                                                                    messages.push({
                                                                                        role: 'appointmentpoc',
                                                                                        content: ''
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                    });
                                                                                }
                                                                                else {
                                                                                    messages.push({
                                                                                        role: 'assistant',
                                                                                        content: 'Certo, estamos finalizando o chat.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'Além da consulta médica, para você se sentir melhor logo, aqui estão os medicamentos que mais fazem sentido para você.'
                                                                                    },{
                                                                                        role: 'assistant',
                                                                                        content: 'O uso de medicação pode trazer riscos, dentre eles alergias e eventos adversos. Procure sempre o médico e o farmacêutico. Leia a bula. Se persistirem os sintomas, o médico deverá ser consultado.'
                                                                                    });
                                                                                }

                                                                                this.setState({
                                                                                    diagnosis: res1.data.diagnoses,
                                                                                    productsList: res1.data.products,
                                                                                    messages: messages,
                                                                                    isLoadingProductsList: false
                                                                                });
                                                                            });
                                                                    }
                                                                })
                                                                .catch(err => {
                                                                    let lastMessages = this.state.messages;
                                                                    lastMessages.push({
                                                                        role: 'assistant',
                                                                        content: '<a href='
                                                                    })

                                                                    this.setState({
                                                                        isRecommendingDoctor: true
                                                                    });
                                                                });


                                                            if (this.state.cartId == '') {
                                                                createCart(this.state.clientToken, this.state.clientModule)
                                                                    .then(_res => {
                                                                        this.setState({ cartId: _res.data.orderFormId })
                                                                    })
                                                            }
                                                        });


                                                }
                                            }
                                            else {
                                                this.myRef.current.scrollIntoView();
                                                this.textLog1.current.focus();
                                            }
                                        })
                                    }
                                }
                            });
                    }
                })
        }
    }

    removeMessageDelay() {
        setTimeout(function() {
            this.setState({contactStatus: 0})
        }.bind(this), 4000)
    }

    setIdentifier(event) {
        if (event)
            event.preventDefault();

        if (!this.state.identifier.includes('_') && this.state.identifier !== '' && (this.state.identifier.length == 11 || this.state.identifier.length == 14))
            this.setState({ hasSentIdentifier: true });
    }

    inputPrivacyChange(e) {
        this.setState({ checkedPrivacy: e.target.checked });
    }

    inputChatChange(e, key) {
        this.setState({ [key]: e.target.value });
    }

    onEnterPress(e) {
        if(e.keyCode == 13 && e.shiftKey == false) {
            e.preventDefault();
            this.postChat(e);
        }
    }

    newChat() {
        this.setState({
            hasSelectedSymptom: false,
            firstSymptom: '',
            messages: [],
            chatStatus: true,
            messageSent: '',
            hasSentIdentifier: false,
            identifier: '',
            hasAddedChat: false,
            hasConsent: false
        });
    }

    isRecommendingDoctor(lastMessage) {
        if (lastMessage.includes('consulta')) {
            if (lastMessage.includes('marcar') || lastMessage.includes('agend') || lastMessage.includes('prefer'))
                return true;
        }
        if (lastMessage.includes('indi')) {
            if (lastMessage.includes('profissional') || lastMessage.includes('clínica') || lastMessage.includes('dentista') || (lastMessage.includes('próximo') && lastMessage.includes('você')) || lastMessage.includes('médico'))
                return true;
        }
        if ( (lastMessage.includes('recomenda') && lastMessage.includes('profissional')) || 
            (lastMessage.includes('sugerir') && lastMessage.includes('médico')) || 
            (lastMessage.includes('procura') && lastMessage.includes('opção') && lastMessage.includes('teleconsulta'))
            )
                return true;
    }

    sliceMessage(message) {
        if (message.includes('xyz.'))
            return message.slice(0, message.lastIndexOf('.', message.lastIndexOf('.')-1))
        if (message.includes('xyz'))
            return message.slice(0, message.lastIndexOf('.'));
        return message;
    }

    shutDownChat(isRecommendingDoctor, hasEndedChat) {
        let newMessages = this.state.messages;
        if(!this.state.hasRenanSentPrompt) {
            // newMessages.push({
            //     role: 'assistant',
            //     content: 'Precisou de médico?'
            // },{
            //     role: 'assistant',
            //     content: '<a href='
            // })

            // Alterar layout quando chatStatus estiver igual a false
            this.setState({
                chatStatus: false,
                isRecommendingDoctor: isRecommendingDoctor,
                hasEndedChat: hasEndedChat
            });
        }
    }

    handleCart(index, productPrice, productId, addingProduct) {
        let vtexIndex = 0;
        let _cartList = this.state.cartList;
        let cartListObj = {
            quantity: 0,
            cartIndex: 0
        }

        if (addingProduct) {

            ReactGA.event({
                category: "IA conversacional",
                action: "IA - adicionou produto no carrinho",
                label: `IA - id do produto ${productId} - id do carrinho ${this.state.cartId}`
            });

            ReactGA.event({
                category: "IA conversacional",
                action: `IA - adicionou produto no carrinho na posição ${index}`
            });

            if (_cartList[index]) {
                cartListObj.quantity = _cartList[index].quantity + 1;
                cartListObj.cartIndex = _cartList[index].cartIndex;
            }
            else {
                cartListObj.quantity = 1;
                cartListObj.cartIndex = Object.keys(_cartList).length;
            }

            this.manageCartTicket(productPrice, true)

            addProductToCart(this.state.cartId, cartListObj.quantity, productId, this.state.clientToken, this.state.clientModule)
                .then(res => {
                    _cartList[index] = cartListObj;
                    this.setState({ 'cartList': _cartList });
                });
        }
        else {

            ReactGA.event({
                category: "IA conversacional",
                action: "IA - removeu produto no carrinho",
                label: `IA - id do produto ${productId} - id do carrinho ${this.state.cartId}`
            });

            this.manageCartTicket(productPrice, false)

            removeProductFromCart(_cartList[index].cartIndex, _cartList[index].quantity - 1, this.state.cartId, this.state.clientToken, this.state.clientModule)
                .then(res => {
                    _cartList[index].quantity = _cartList[index].quantity - 1;
                    this.setState({ 'cartList': _cartList });
                });
        }
    }

    validateConsent() {
        if (this.state.checkedPrivacy) {
            if (this.state.clientId != 11)
                this.setState({
                    hasConsent: true,
                    hasSentIdentifier: true
                }, () => this.textLog1.current.focus());

            if (this.state.clientId == 11 && this.state.identifier != '')
                this.setState({
                    hasConsent: true,
                    hasSentIdentifier: true
                }, () => this.textLog1.current.focus());
        }
    }

    manageCartTicket(price, isAdding) {
        let cartTicket = (isAdding)? this.state.cartTicket + price : this.state.cartTicket - price;
        this.setState({ cartTicket: cartTicket });
    }

    handleComboCart(isAdding) {
        let fetchArray = [];
        let orderItems = [];

        if (isAdding) {
            ReactGA.event({
                category: "IA conversacional",
                action: "IA - adicionou combo no carrinho"
            });

            for (let i = 0; i < this.state.combo.skus.length; i++) {
                let obj = {
                    "id": this.state.combo.skus[i],
                    "quantity": this.state.comboInCart + 1,
                    "seller": "1"
                };
                orderItems.push(obj);
            }

            bulkAddProductToCart(this.state.cartId, orderItems, this.state.clientToken, this.state.clientModule)
                .then(res => {
                    this.setState({ comboInCart: this.state.comboInCart + 1 });
                });
        }
        else {
            ReactGA.event({
                category: "IA conversacional",
                action: "IA - removeu combo no carrinho"
            });

            for (let i = 0; i < this.state.combo.skus.length; i++) {
                let obj = {
                    "quantity": this.state.comboInCart - 1,
                    "index": i
                };
                orderItems.push(obj);
            }

            bulkRemoveProductFromCart(orderItems, this.state.cartId, this.state.clientToken, this.state.clientModule)
                .then(res => {
                    this.setState({ comboInCart: this.state.comboInCart - 1 });
                });
        }
    }

    swipeProduct(obj, isPrimary, carousselLineIndex) {
        let primaryText = isPrimary? 'primario' : 'secundario';

        ReactGA.event({
            category: "IA conversacional",
            action: `IA - swipe produto ${primaryText} na linha ${carousselLineIndex} indice ${obj.activeIndex}`
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <meta name="robots" content="noindex"/>
                </Helmet>
                {this.state.isClientInvalid?
                    <div className='first-container'>
                        <div className='invalid-token-container'>
                            <div className='invalid-token'>Token inválido</div>
                        </div>
                        <div className="logo-container">
                            <div className="powered-by-container">
                                <div className="powered-by">
                                    <span className="cnpj">Powered by</span>
                                    <span>Balto</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : 
                    <section className={(this.state.isClientInvalid)? 'display-none' : 'first-container'}>
                        <div className={(this.state.isPlatformWeb) ? '' : 'mobile-class'}>
                            <div className={(!this.state.hasConsent)? ((!this.state.isClientDigital && this.state.hasConsent)? 'identifier-container identifier-container-key-board' : 'identifier-container'): 'display-none'}>
                                {this.state.showIdentifier? 
                                    <h2>Esta é uma anamnese farmacêutica* e não substitui uma consulta médica.</h2>
                                    : <h2>Este serviço serve para auxiliar seu médico, e não substitui a consulta.</h2>
                                }
                                <div className='explanation-anamnese'>*coleta de dados sobre o paciente através de perguntas.</div>

                                <div className={(!this.state.hasSentIdentifier) ?  'identifier-container-phone' : 'display-none'}>
                                    <h2>Telefone do cliente</h2>
                                    <div className="identifier-container-main">
                                        <Form onSubmit={(e) => this.setIdentifier(e)} className="identifier-form">
                                            <Form.Group controlId="identifier" className="identifier-input">
                                                <InputMask
                                                    onChange={(e) => this.inputChatChange(e, 'identifier')}
                                                    placeholder="(99) 99999-9999"
                                                    autoFocus
                                                    value={this.state.identifier}
                                                    mask='(99) 99999-9999'>
                                                </InputMask>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className='checkbox-privacy-policy'>
                                    <Form.Check 
                                        required
                                        onChange={(e) => this.inputPrivacyChange(e)}
                                        value={this.state.checkedPrivacy}
                                        type='checkbox'
                                        id='checkbox'
                                    />
                                    <div className='terms-of-use-text'>Eu concordo com os <a target="_blank" href="/termos-de-uso">termos de uso</a> e desejo continuar.</div>
                                </div>
                                <Button onClick={() => this.validateConsent()} className="identifier-button" type="submit"><strong>CONTINUAR</strong></Button>
                                <div className="powered-by">
                                    <span className="cnpj"><i>powered by</i></span>
                                    <span>BALTO</span>
                                </div>
                            </div>
                        </div>
                        <div className={(this.state.isPlatformWeb) ? '' : 'mobile-class'}>
                            <div className={(this.state.hasSentIdentifier && this.state.hasConsent)? 'display-none' : (!this.state.isClientDigital && this.state.hasConsent)? 'logo-container logo-container-key-board' : 'logo-container'}>
                                <div className="powered-by-container">
                                    <img className="display-none" src={this.state.clientLogoTwo} />
                                    <img className="clinic-farma" src={this.state.clientLogoOne} />
                                </div>
                                <div>
                                    <img src={this.state.clientLogoTwo} />
                                    <span className="cnpj display-none">CNPJ 48.554.329/0001-20</span>
                                </div>
                                <span className="space display-none">E</span>
                            </div>
                        </div>

                        <div className={((this.state.hasSentIdentifier && this.state.hasConsent) || (this.state.hasConsent && !this.state.showIdentifier))? '' : 'display-none'}>
                            <div className={(this.state.isPlatformWeb) ? '' : 'mobile-class'}>
                                <div className={(this.state.hasEndedChat) ? 'exchanging-messages-ended' : ((this.state.isClientDigital)? 'exchanging-messages' : 'exchanging-messages exchanging-messages-non-digital')}>
                                    {this.state.messages.slice(1, this.state.messages.length).map((message, index) =>
                                        <div id={"item-" + index} key={index} className={"message-pattern message-type-" + message.role}>
                                            {(message.role === 'user')?
                                                <strong>Você:  </strong>
                                                : 
                                                (message.role == 'appointmentpoc')?
                                                    ""
                                                    : <strong>Assistente de Saúde:  </strong>
                                            }
                                            {(message.content == '<a href=')?
                                                <span>Dado o seu contexto de saúde é importante que você realize uma consulta médica. O <a onClick={() => ReactGA.event({ category: "IA conversacional", action: "IA - clicou agendar consulta", label: "IA - clicou agendar consulta" })} href="https://semprebem.ciclic.com.br/?utm_source=balto" target="_blank">Sempre Bem Ouro+</a> é o programa de apoio a saúde da Pague Menos Extrafarma. Com ele, você terá direito a teleconsultas 24h por dia, com clínico geral, psicólogo e nutricionista. Além de serviços farmacêuticos gratuitos e muito mais.</span>
                                                : 
                                                (message.role == 'appointmentpoc')?
                                                    <span>Você ganhou <strong>50% de desconto</strong> na consulta por whatsapp com <strong>médico da USP</strong>. 
                                                        <br/><br/>De R$19,90 por <strong>R$9,90</strong>.<a href="https://mpago.la/1fpJRgu" target="_blank" onClick={() => ReactGA.event({ category: "IA conversacional", action: "IA - clicou em pagar consulta por texto"})}> CLIQUE AQUI</a> para ser atendido agora.
                                                    </span>
                                                    : <span className="content" dangerouslySetInnerHTML={{__html: message.content}}></span>
                                                
                                            }
                                        </div>
                                    )}
                                    <div className={(this.state.isRecommendingDoctor)? 'display-none' : ''}>
                                        <div className={((this.state.hasSentMessage && !this.state.chatStatus) || this.state.isLoadingProductsList)? 'message-pattern message-type-assistant' : 'display-none'}>
                                            <strong>Assistente de Saúde:  </strong>
                                            <span className={this.state.isTyping? 'typing' : 'display-none'}>Digitando</span>
                                            <TypeAnimation
                                              sequence={[
                                                '.',
                                                500,
                                                '..',
                                                500,
                                                '...',
                                                500
                                              ]}
                                              wrapper="span"
                                              speed={10}
                                              style={{ fontSize: '16px', display: 'inline-block' }}
                                              repeat={Infinity}
                                              cursor={false}
                                            />
                                        </div>
                                    </div>
                                    <div ref={this.myRef}></div>

                                    {(this.state.combo.price)?
                                        <div className='combo-container'>
                                            <div className='combo-products'><strong>Promoção contendo:</strong></div>
                                            <div className='explanation-container'>
                                                {this.state.combo.explanation.map((explanation, explanationIndex) => (
                                                    <div id={"explanation-item-" + explanationIndex} key={explanationIndex} className='combo-products-explanation'>
                                                    - <strong>{(explanation.split(" "))[0]}</strong> {explanation.substr(explanation.indexOf(" ") + 1)}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="combo-image-container">
                                                <img className="combo-image" src={comboImage}/>
                                            </div>
                                            <div className='combo-price'>R$ {this.state.combo.price}</div>
                                            {(this.state.comboInCart > 0)?
                                                <div className='product-quantity-container'>
                                                    <span onClick={() => this.handleComboCart(false)} className="product-quantity-icon first-icon">-</span>
                                                    <span className="product-quantity">{this.state.comboInCart}</span>
                                                    <span onClick={() => this.handleComboCart(true)} className="product-quantity-icon last-icon">+</span>
                                                </div>
                                                :
                                                <Button onClick={() => this.handleComboCart(true)} className='identifier-button drug-button'>ADICIONAR</Button>
                                            }
                                            {(this.state.isClientCustomerFacing && this.state.clientModule != '')?
                                                <div>
                                                    <a href={'https://www.extrafarma.com.br/checkout/?orderFormId=' + this.state.cartId + '#/cart'} target="_blank" className={(this.state.comboInCart > 0)? 'checkout-button continue-payment' : 'display-none'} onClick={() => ReactGA.event({category: "IA conversacional",action: "IA - seguiu para pagamento",label: `IA - id do carrinho ${this.state.cartId}`, value: this.state.cartTicket})}>SEGUIR PARA PAGAMENTO</a>
                                                </div>
                                                : <div></div>
                                            }
                                        </div>
                                        : <div></div>
                                    }


                                    {(!this.state.isClientDigital)?
                                        <div className="container-striper-container">
                                            {(this.state.productsList && this.state.productsList.length > 0)?
                                                this.state.productsList.map((symptom, symptomIndex) => (
                                                (symptomIndex == 0 || this.state.productsList[symptomIndex - 1].symptom != symptom.symptom)?
                                                    <div className="striped-product-container" id={"symptom-item-" + symptomIndex} key={symptomIndex} >
                                                        {(symptom.symptom == '-')?
                                                            <div className="list-drug-title">Para tratamento da <u><strong>{this.state.diagnosis}</strong></u>:</div>
                                                            : <div className="list-drug-title">Para tratamento do sintoma <u><strong>{symptom.symptom}</strong></u>:</div>
                                                        }
                                                        <Table className="product-container">
                                                            <thead>
                                                                <tr>
                                                                    <th>Nome do produto</th>
                                                                    <th className={(this.state.clientId == 11)? "display-none": ""}>Preço</th>
                                                                    <th className={(this.state.clientId == 11)? "display-none": ""}>Lucro</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.productsList.map((product, productIndex) => (
                                                                    (this.state.productsList[productIndex].symptom == this.state.productsList[symptomIndex].symptom)?
                                                                        <tr key={symptomIndex + productIndex}>
                                                                            <td>{product.productName}</td>
                                                                            <td className={(this.state.clientId == 11)? "display-none": ""}>R${product.price}</td>
                                                                            <td className={(this.state.clientId == 11)? "display-none": ""}>R${product.margin}</td>
                                                                        </tr>
                                                                        : ""
                                                                    
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    : ""
                                            ))
                                            : ""
                                            }
                                        </div>
                                        :
                                        <div>
                                            <div className="list-drugs-web">
                                                {this.state.productsList.map((symptom, symptomIndex) => (
                                                    (symptom.products[0] == 'Procurar médico')?
                                                        <div></div>
                                                        :
                                                        <div id={"symptom-item-" + symptomIndex} key={symptomIndex} >
                                                            <div className="list-drug-title">Para tratamento do sintoma <strong>{symptom.symptom}</strong>:</div>
                                                            <div className="slider-container slider-container-web">
                                                                <Swiper 
                                                                    onSlideChange={(e) => this.swipeProduct(e, true, symptomIndex)}
                                                                    slidesPerView={4}
                                                                    spaceBetween={30}
                                                                    pagination={{
                                                                        clickable: true,
                                                                    }}
                                                                    navigation={true}
                                                                    modules={[Pagination, Navigation]}
                                                                    className="mySwiper"
                                                                    >
                                                                    {symptom.products.map((product, productIndex) => (
                                                                        <SwiperSlide key={productIndex}>
                                                                            <div className="drug-image-container"><img className="drug-image" src={product.items[0].images[0].imageUrl}/></div>
                                                                            <span className='drug-name'>{product.productTitle}</span>
                                                                            {(this.state.isClientCustomerFacing)?
                                                                                <div className='drug-price'>R$ {(product.items[0].sellers[0].commertialOffer.Price).toString().replace(".", ",")}</div>
                                                                                : <div></div>
                                                                            }

                                                                            {(this.state.isClientCustomerFacing)?
                                                                                ((this.state.cartList[(productIndex.toString() + symptomIndex.toString())]) && this.state.cartList[(productIndex.toString() + symptomIndex.toString())].quantity > 0)?
                                                                                    <div className='product-quantity-container'>
                                                                                        <span onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, false)} className="product-quantity-icon first-icon">-</span>
                                                                                        <span className="product-quantity">{this.state.cartList[(productIndex.toString() + symptomIndex.toString())].quantity}</span>
                                                                                        <span onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, true)} className="product-quantity-icon last-icon">+</span>
                                                                                    </div>
                                                                                    :
                                                                                    <Button onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, true)} className='identifier-button drug-button'>ADICIONAR</Button>
                                                                                : <div></div>
                                                                            }
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Swiper>
                                                            </div>
                                                        </div>
                                                ))}
                                            </div>
                                            <div className="list-drugs-mobile">
                                                {this.state.productsList.map((symptom, symptomIndex) => (
                                                    (symptom.products[0] == 'Procurar médico')?
                                                        <div></div>
                                                        :
                                                        <div id={"symptom-item-" + symptomIndex} key={symptomIndex} >
                                                            <div className="list-drug-title">Para tratamento do sintoma <strong>{symptom.symptom}</strong>:</div>
                                                            <div className="slider-container slider-container-web">
                                                                <Swiper 
                                                                    onSlideChange={(e) => this.swipeProduct(e, true, symptomIndex)}
                                                                    slidesPerView={1}
                                                                    spaceBetween={30}
                                                                    pagination={{
                                                                        clickable: true,
                                                                    }}
                                                                    navigation={true}
                                                                    modules={[Pagination, Navigation]}
                                                                    className="mySwiper"
                                                                    >
                                                                    {symptom.products.map((product, productIndex) => (
                                                                        <SwiperSlide key={productIndex}>
                                                                            <div className="drug-image-container"><img className="drug-image" src={product.items[0].images[0].imageUrl}/></div>
                                                                            <span className='drug-name'>{product.productTitle}</span>
                                                                            {(this.state.isClientCustomerFacing)?
                                                                                <div className='drug-price'>R$ {(product.items[0].sellers[0].commertialOffer.Price).toString().replace(".", ",")}</div>
                                                                                : <div></div>
                                                                            }

                                                                            {(this.state.isClientCustomerFacing)?
                                                                                ((this.state.cartList[(productIndex.toString() + symptomIndex.toString())]) && this.state.cartList[(productIndex.toString() + symptomIndex.toString())].quantity > 0)?
                                                                                    <div className='product-quantity-container'>
                                                                                        <span onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, false)} className="product-quantity-icon first-icon">-</span>
                                                                                        <span className="product-quantity">{this.state.cartList[(productIndex.toString() + symptomIndex.toString())].quantity}</span>
                                                                                        <span onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, true)} className="product-quantity-icon last-icon">+</span>
                                                                                    </div>
                                                                                    :
                                                                                    <Button onClick={() => this.handleCart((productIndex.toString() + symptomIndex.toString()), product.items[0].sellers[0].commertialOffer.Price, product.items[0].itemId, true)} className='identifier-button drug-button'>ADICIONAR</Button>
                                                                                : <div></div>
                                                                            }
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Swiper>
                                                            </div>
                                                        </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                    {(this.state.secondaryProductsList.length > 0)?
                                        <div>
                                            <div className='list-drug-title'>Outros produtos para você:</div>
                                            <Swiper 
                                                onSlideChange={(e) => this.swipeProduct(e, false, 0)}
                                                slidesPerView={1}
                                                spaceBetween={30}
                                                pagination={{
                                                    clickable: true,
                                                }}
                                                navigation={true}
                                                modules={[Pagination, Navigation]}
                                                className="mySwiper"
                                                >
                                                {this.state.secondaryProductsList.map((symptom, symptomIndex) => (
                                                    symptom.products.map((product, productIndex) => (
                                                        <SwiperSlide key={productIndex}>
                                                            <div className="drug-image-container"><img className="drug-image" src={(product.items)? product.items[0].images[0].imageUrl : product.image}/></div>
                                                            <span className='drug-name'>{(product.productTitle)? product.productTitle : product.title}</span>
                                                            {(this.state.isClientCustomerFacing && this.state.clientModule != '')?
                                                                <div className='drug-price'>R$ {(product.items[0].sellers[0].commertialOffer.Price).toString().replace(".", ",")}</div>
                                                                : <div></div>
                                                            }
                                                            
                                                            {(this.state.isClientCustomerFacing && this.state.clientModule != '')?
                                                                ((this.state.cartList[('x' + productIndex.toString())]) && this.state.cartList[('x' + productIndex.toString())].quantity > 0)?
                                                                    <div className='product-quantity-container'>
                                                                        <span onClick={() => this.handleCart(('x' + productIndex.toString()),product.items[0].sellers[0].commertialOffer.Price , product.items[0].itemId, false)} className="product-quantity-icon first-icon">-</span>
                                                                        <span className="product-quantity">{this.state.cartList[('x' + productIndex.toString())].quantity}</span>
                                                                        <span onClick={() => this.handleCart(('x' + productIndex.toString()),product.items[0].sellers[0].commertialOffer.Price , product.items[0].itemId, true)} className="product-quantity-icon last-icon">+</span>
                                                                    </div>
                                                                    :
                                                                    <Button onClick={() => this.handleCart(('x' + productIndex.toString()),product.items[0].sellers[0].commertialOffer.Price , product.items[0].itemId, true)} className='identifier-button drug-button'>ADICIONAR</Button>
                                                                : <div></div>
                                                            }
                                                        </SwiperSlide>
                                                    ))
                                                ))}
                                            </Swiper>
                                        </div>
                                        :<div></div>
                                    }
                                    {(this.state.needDoctorSymptoms.length == 0)?
                                        <div></div>
                                        :
                                        <div>
                                            <div className="message-pattern message-type-assistant">
                                                <strong>Assistente de Saúde:  </strong> Para o(s) sintoma(s)
                                                {this.state.needDoctorSymptoms.map((symptom, symptomIndex) => (
                                                    <span key={symptomIndex}><strong> {symptom}</strong> e </span>
                                                ))}
                                                seu contexto de saúde é importante você realize uma consulta médica
                                            </div>
                                        </div>
                                    }

                                    {(this.state.isClientCustomerFacing && this.state.productsList.length > 0)?
                                        <div>
                                            <a href={'https://www.extrafarma.com.br/checkout/?orderFormId=' + this.state.cartId + '#/cart'} target="_blank" className={(Object.keys(this.state.cartList).length > 0)? 'checkout-button continue-payment' : 'display-none'} onClick={() => ReactGA.event({category: "IA conversacional",action: "IA - seguiu para pagamento",label: `IA - id do carrinho ${this.state.cartId}`})}>SEGUIR PARA PAGAMENTO</a>
                                        </div>
                                        : <div></div>
                                    }
                                </div>
                            </div>
                            <div className={(this.state.isPlatformWeb) ? '' : 'mobile-class'}>
                                <div className={(this.state.hasEndedChat) ? 'display-none' : 'first-container-main'}>
                                    <div className="first-left-container">
                                        <Form onSubmit={(e) => this.postChat(e)} className="chat-form">
                                            <Form.Group controlId="chat" className="inline-input">
                                                <Form.Control
                                                    ref={this.textLog1}
                                                    className={(this.state.chatStatus)? "inline-textarea" : 'display-none'}
                                                    as="textarea"
                                                    onKeyDown={this.onEnterPress}
                                                    onChange={(e) => this.inputChatChange(e, 'messageSent')}
                                                    autoFocus
                                                    name="chat"
                                                    value={this.state.messageSent} />
                                                <Form.Control
                                                    ref={this.textLog}
                                                    className={(this.state.chatStatus)? "display-none" : 'inline-textarea'}
                                                    as="textarea"
                                                    onKeyDown={this.onEnterPress}
                                                    onChange={(e) => this.inputChatChange(e, 'messageSent')}
                                                    disabled
                                                    name="chat"
                                                    value={this.state.messageSent} />
                                            </Form.Group>
                                            {this.state.hasEndedChat ?
                                                <div></div>
                                                : <Button className={"submit-form " + (this.state.chatStatus? '' : 'input-disable')} type="submit">
                                                    <img className="icon-enviar" src={IconEnviarImg}/>
                                                </Button>
                                            }
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
                <div ref={this.myRefMobile}></div>
            </div>
        )
    }
}

export default Web;



